const RELOAD_AT_KEY = "UNU_HEALTH_STALE_CHUNK_RELOAD_AT";

// After a deploy, lazy chunks from the previous build no longer exist and
// CloudFront negatively caches the resulting 404s for ~3 minutes. A single
// reload picks up fresh chunk URLs from the uncached index.html; if the
// failure repeats within the cooldown we are inside the negative-cache
// window, so we let the error reach the ErrorBoundary instead of
// reload-looping.
const RELOAD_COOLDOWN_MS = 5 * 60 * 1000;

function retrieveLastReloadAt(): number {
  try {
    return Number(window.sessionStorage.getItem(RELOAD_AT_KEY)) || 0;
  } catch {
    return 0;
  }
}

function persistLastReloadAt(timestamp: number) {
  try {
    window.sessionStorage.setItem(RELOAD_AT_KEY, String(timestamp));
  } catch {
    // Storage can be unavailable (private mode / blocked); still reload once.
  }
}

export function registerReloadOnStaleChunk(
  reload: () => void = () => window.location.reload()
) {
  const handlePreloadError = (event: Event) => {
    if (Date.now() - retrieveLastReloadAt() < RELOAD_COOLDOWN_MS) {
      return;
    }
    persistLastReloadAt(Date.now());
    event.preventDefault();
    reload();
  };

  window.addEventListener("vite:preloadError", handlePreloadError);

  return () => {
    window.removeEventListener("vite:preloadError", handlePreloadError);
  };
}
